const API_BASE_URL = (
  process.env.VUE_APP_API_BASE_URL ||
  process.env.VUE_APP_RECHARGE_API_BASE_URL ||
  'https://raya.smnm.xyz/api/v1'
).replace(/\/$/, '')

function httpUrl(value) {
  const url = typeof value === 'string' ? value.trim() : ''
  return /^https?:\/\//i.test(url) ? url : null
}

/**
 * Reads the Google Play and App Store links configured in Admin (App main configuration).
 * Each link is null when it is not configured or the backend is unreachable, so the page keeps its
 * built-in links instead of showing a dead button.
 */
export async function getStoreLinks() {
  try {
    const response = await fetch(`${API_BASE_URL}/party/version/getPublicConfig`, {
      headers: { Accept: 'application/json' }
    })
    if (!response.ok) return { googlePlayUrl: null, appStoreUrl: null }

    const payload = await response.json()
    if (payload && payload.code != null && Number(payload.code) !== 200) {
      return { googlePlayUrl: null, appStoreUrl: null }
    }

    const config = (payload && payload.data) || {}
    return {
      googlePlayUrl: httpUrl(config.googlePlayUrl),
      appStoreUrl: httpUrl(config.appStoreUrl)
    }
  } catch (error) {
    return { googlePlayUrl: null, appStoreUrl: null }
  }
}
